import { render, staticRenderFns } from "./AtendimentoEnfermagemItem.vue?vue&type=template&id=6a8c89f1&"
import script from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports